import WsService from "../../WsService";
import UserSessionService from "../../UserSessionService";
import BasicAuthGenerator from "../../../utils/BasicAuthGenerator";
import ReportingDeclaration from "../../../domain/Transaction/reporting.declaration/ReportingDeclaration";

const END_POINT_BASE = '/reporting/declaration'
export default class ReportingDeclarationService {


    static getLatestVersion(requiresSignature) {
        let registrationHeaders = UserSessionService.retrieveRegisteringAuth();
        let headers = {
            "Authorization": BasicAuthGenerator.create(registrationHeaders["registering-partner-username"], registrationHeaders["registering-partner-password"]),
        };
        let endpoint = END_POINT_BASE + '/latest?requires-signature=' + requiresSignature;
        return WsService.getWithHeaders(endpoint, {}, 200, headers).then(
            response => {
                return new ReportingDeclaration(response)
            },
            error => {
                return error;
            }
        )
    }

    static retrieveByVersion(version) {
        let registrationHeaders = UserSessionService.retrieveRegisteringAuth();
        let headers = {
            "Authorization": BasicAuthGenerator.create(registrationHeaders["registering-partner-username"], registrationHeaders["registering-partner-password"]),
        };
        let endpoint = END_POINT_BASE + '?version=' + version;
        return WsService.getWithHeaders(endpoint, {}, 200, headers).then(
            response => {
                return new ReportingDeclaration(response);
            },
            error => {
                return error;
            }
        )
    }
}